const createInstance = (sparePartsServiceClient, sparePartsAnchor, sparePartsComponent) => {

  const handleInitialPageLoad = async (parentProductCode) => {
    try {
      const spareParts = await fetchSpareParts(sparePartsServiceClient, parentProductCode);

      if (spareParts.length > 0) {
        sparePartsComponent.renderSuccess(spareParts, parentProductCode);
        sparePartsAnchor.enable();
      } else {
        sparePartsAnchor.disable();
        sparePartsComponent.destroy();
      }
    } catch (error) {
      sparePartsAnchor.disable();
      sparePartsComponent.destroy();
    }
  };

  async function fetchSpareParts(sparePartsServiceClient, parentProductCode) {
    const response = await sparePartsServiceClient.fetchSpareParts(parentProductCode);

    return response.spareParts || [];
  }

  return {
    handleInitialPageLoad
  };
};

export default createInstance;
